import { render, staticRenderFns } from "./NominacionDetalles.vue?vue&type=template&id=3602e32c"
import script from "./NominacionDetalles.vue?vue&type=script&lang=js"
export * from "./NominacionDetalles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports